module.exports = __webpack_public_path__ + "img/da.888e9c73.png";